import { rest } from 'msw';
import { baseURL } from '@/__mocks__/utils';
import { tokenEndpoint } from './token';

export const tokenHandlers = [
  rest.post(baseURL(tokenEndpoint), (req, res, ctx) => res(ctx.status(200))),
];
